export interface RequestEmailPayload {
  projectNumber: number;
  requestType: string;
  requestNumber: string;
  subjectSuffix: string;
  body: string;
  cc: string[];
  files: File[];
}

export interface RequestEmailResponse {
  messageId: string;
  sentAtUtc: string;
  to: string;
  cc: string[];
  subject: string;
}

export interface RequestEmailProblemDetails {
  code?: string;
  message?: string;
  title?: string;
  detail?: string;
  status?: number;
}

export const REQUEST_EMAIL_UI_CONFIG = {
  recipientPrefix: 'd',
  recipientDomain: 'de-simone.ca',
  maxFiles: 10,
  maxFileBytes: 10 * 1024 * 1024,
  maxCombinedBytes: 25 * 1024 * 1024
} as const;
